import "core-js/modules/es.array.push.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import util from '@/libs/util.js';
export default {
  methods: {
    handleMenuSelect: function handleMenuSelect(index, indexPath) {
      if (/^d2-menu-empty-\d+$/.test(index) || index === undefined) {
        this.$message.warning('临时菜单');
      } else if (/^https:\/\/|http:\/\//.test(index)) {
        util.open(index);
      } else {
        if (index.indexOf('?') == -1) {
          //普通菜单
          this.$router.push({
            path: index
          });
        } else {
          //菜单上有传参数，且参数是J3D链接
          var path = index.substring(0, index.indexOf('?'));
          var str = index.substring(index.indexOf('?') + 1);
          console.log('path', path);
          console.log('str', str);
          var query = {};
          query[str.substring(0, str.indexOf('='))] = str.substring(str.indexOf('=') + 1);
          console.log('query', query);
          this.$router.push({
            path: path,
            query: query
          });
        }
      }
    }
  }
};